export default __webpack_public_path__ + "static/media/Tmenu_Header_App.fb5d7d66.png";